export function normalizeVqcaPsl(record: Record<string, unknown>, selected = record.pslId || record.psliD || record.pslID || record.pslid) {
  if (typeof selected !== 'string' || !selected.trim()) return false;
  let changed = false;
  const fields = new Set(['pslId', ...Object.keys(record).filter(key => key.toLowerCase() === 'pslid')]);
  for (const field of fields) {
    if (record[field] !== selected) {
      record[field] = selected;
      changed = true;
    }
  }
  return changed;
}